// use-refetch-on-foreground.ts
//
// Calls `onForeground` whenever the browser tab returns to the foreground
// (becomes visible again, or the window regains focus). Used to refetch
// server state when the student comes back to the portal tab — e.g. after
// playing a match in another tab — instead of relying solely on TanStack's
// global `refetchOnWindowFocus`.
import { useEffect } from 'react';

export function useRefetchOnForeground(onForeground: () => void) {
  useEffect(() => {
    const onVisible = () => {
      if (document.visibilityState === 'visible') onForeground();
    };
    document.addEventListener('visibilitychange', onVisible);
    window.addEventListener('focus', onForeground);
    return () => {
      document.removeEventListener('visibilitychange', onVisible);
      window.removeEventListener('focus', onForeground);
    };
  }, [onForeground]);
}
